import { useSelector } from 'react-redux'

const useLang = () => {
  const lang = useSelector((state) => state.lang.ui.lang)

  return lang || ''
}

export default useLang
